module.exports = __webpack_public_path__ + "static/media/84.0b5f5dfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/84.jpg
// module id = 1018
// module chunks = 0